module.exports = __webpack_public_path__ + "media/images/webshop-bg-8de97fa3944bdcb98c9a3f99978b6a2d.svg";